import type { Questionnaire } from "@medplum/fhirtypes";
import { QUESTIONNAIRE_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Questionnaire resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useQuestionnaireSubscription = createSubscriptionHook<Questionnaire>(
  "Questionnaire",
  QUESTIONNAIRE_COLLECTION_NAME,
);
